"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getNumber = function getNumber(value, defaultValue) {
  var validator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  var parsed = parseFloat(value);
  return !Number.isNaN(parsed) && validator(parsed) ? parsed : parseFloat(defaultValue);
};

var _default = getNumber;
exports["default"] = _default;